export const LOGIN_REQUEST_PATH = 'auth/login';
